<template>
    <div class="survey-note-form-handouts">

        <!-- list selected handouts -->

        <b-card no-body
                @click.stop="showModal()">

            <b-card-body>
                <div class="survey-note-form-handouts__no-selections"
                     v-if="selectionCount == 0">
                    {{ $i18n.gt('LABEL_HANDOUTS_NONE_SELECTED') }}
                </div>
                <div v-else>
                    <ul>
                        <li v-for="(handout, i) in checkedHandouts" :key="i">
                            {{ handout.label }}
                        </li>
                    </ul>
                </div>
            </b-card-body>
        </b-card>

        <!-- selection modal -->

        <b-modal hide-footer
                 no-close-on-backdrop
                 id="handoutsModal">

            <template v-slot:modal-header>
                <h5>{{ $i18n.gt('HEADING_HANDOUTS') }}</h5>

                <b-form-input class="survey-note-form-handouts__search-input"
                              placeholder="Search"
                              v-model="titleSearch">
                </b-form-input>
                <button type="button" aria-label="Close" class="close"
                        @click="hideModal()">x
                </button>
            </template>

            <b-tabs>
                <b-tab class="pt-3"
                       v-for="group in groupedFilteredHandouts" :key="group.heading">
                    <template #title>
                        <h5>{{ group.heading }}</h5>
                    </template>
                    <div v-for="(handout, i) in group.handouts" :key="i">
                        <div class="form-check">
                            <b-form-checkbox class="form-check-input"
                                             v-model="handout.checked"
                                             :value="true"
                                             unchecked-value="">
                                {{ handout.label }}
                            </b-form-checkbox>
                        </div>
                    </div>
                </b-tab>
            </b-tabs>
        </b-modal>

    </div>
</template>

<script>
import Vue from 'vue'
import * as _ from 'lodash'
import Attachments from '@/providers/Attachments'

/**
 * Displays selected handouts for the Practitioner to select for a plan of care,
 * with a modal for editing the selections.
 */
export default Vue.extend({
    name: 'SurveyNoteFormHandouts',
    data () {
        return {
            showCollapse: false,
            practiceHandouts: [],
            titleSearch: ''
        }
    },
    computed: {
        selectionCount () {
            return _.filter(this.handouts, (h) => h.checked).length
        },
        handouts: {
            get () {
                return this.$store.state.draftSurveyNote.handouts
            },
            set (val) {
                this.$store.state.draftSurveyNote.handouts = val
            }
        },
        checkedHandouts () {
            return _.filter(this.handouts, (h) => {
                return h.checked
            })
        },
        filteredHandouts () {
            return _.filter(this.handouts, (h) => {
                return h.checked || h.label.toLowerCase().indexOf(this.titleSearch.toLowerCase()) != -1
            })
        },
        groupedFilteredHandouts () {
            const handoutGroups = Attachments.getGroupedSortedHandouts(this.filteredHandouts)
            return _.map(_.keys(handoutGroups), (group) => {
                // console.log(group, !group)
                let heading = group
                if (!heading || heading == 'undefined') {
                    heading = 'Uncategorized'
                } else if (heading == Attachments.DEFAULT_HANDOUTS_GROUP) {
                    heading = Attachments.DEFAULT_HANDOUTS_GROUP_LABEL
                }

                return {
                    heading: heading,
                    handouts: handoutGroups[group]
                }
            })
        }
    },
    methods: {
        showModal () {
            this.$bvModal.show('handoutsModal')
        },
        hideModal () {
            this.$bvModal.hide('handoutsModal')
        },
    },
})

</script>

<style lang="scss">

.survey-note-form-handouts {
    cursor: pointer;

    .card-body {
        margin: 0 0 -1rem 0 !important;
    }

    .card:hover {
        background-color: #fcfcfc;
    }
}

.survey-note-form-handouts__search-input {
    display: inline-block;
    margin-left: 30px;
    width: 50% !important;
}

.survey-note-form-handouts__no-selections {
    font-style: italic;
    color: #ccc;
    margin-bottom: 1rem;
}

</style>
